import jsCookie from 'js-cookie';
import type { History } from 'history';
import { bootstrap } from './modules/boot-module';
import { fetchMetaTag } from './modules/cms-module';
import { updateHeader, setIsGSAoniOS, setOS } from './modules/header-module';
import { updateMenu } from './modules/menu-module';
import { getUserAgentData } from '../utils/user-agent';
import redirectStateUtil, { COOKIE_NAME } from '../utils/redirect-state-cookie';

type InitializeStore = {
  store: any;
  req?: any;
  history?: History<{ [key: string]: any }>;
};

export default ({ store, req, history }: InitializeStore) => {
  const promises = [];

  if (req) {
    // Server-side & static-side
    const state = redirectStateUtil.get(req);
    promises.push(store.dispatch(fetchMetaTag(req.url)));
    promises.push(store.dispatch(updateHeader(req.url, state)));
    promises.push(store.dispatch(updateMenu(req.url)));
  } else {
    // Client-side
    const redirectStateCookie = jsCookie.get(COOKIE_NAME) || '{}';
    const redirectState = JSON.parse(redirectStateCookie);
    const state = { ...history.location.state, ...redirectState };
    const { os, isGSAoniOS } = getUserAgentData(navigator.userAgent);

    if (redirectStateCookie) {
      jsCookie.remove(COOKIE_NAME);
    }

    promises.push([
      store.dispatch(bootstrap()),
      store.dispatch(setOS(os)),
      store.dispatch(setIsGSAoniOS(isGSAoniOS)),
      store.dispatch(updateHeader(location.pathname, state)),
    ]);
  }

  return Promise.all(promises);
};
